"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContainerStyle = getContainerStyle;
exports.getDropdownListItemStyle = getDropdownListItemStyle;
exports.getDropdownStyle = getDropdownStyle;
exports.getInputStyle = getInputStyle;
exports.getOptionContentStyle = getOptionContentStyle;
exports.getPlaceholderStyle = getPlaceholderStyle;
exports.getPopoverBodyStyle = getPopoverBodyStyle;
exports.getSingleValueStyle = getSingleValueStyle;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _utils = require("../utils");

var _style = require("../utils/style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerStyle(styleArgs) {
  const {
    $disabled,
    $theme
  } = styleArgs;
  const borderRadius = $theme.sizing.scale100;
  const borderStyle = 'solid';
  const borderWidth = '1px';
  const borderColor = (0, _utils.getBorderColor)(styleArgs);
  return {
    alignItems: 'center',
    backgroundColor: $disabled ? $theme.colors.grey10 : $theme.colors.white,
    ...(0, _style.buildBorderStyle)('Color', borderColor),
    ...(0, _style.buildBorderRadiusStyle)(borderRadius),
    ...(0, _style.buildBorderStyle)('Style', borderStyle),
    ...(0, _style.buildBorderStyle)('Width', borderWidth),
    boxShadow: '0px',
    cursor: $disabled ? 'not-allowed' : 'pointer',
    height: '3rem'
  };
}

function getDropdownStyle({
  $theme
}) {
  const borderRadius = $theme.borders.radius200;
  return {
    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: borderRadius,
    borderBottomRightRadius: borderRadius,
    borderBottomLeftRadius: borderRadius
  };
}

function getDropdownListItemStyle({
  $isHighlighted,
  $theme
}) {
  return {
    backgroundColor: $isHighlighted ? $theme.colors.primary50 : 'transparent',
    color: $theme.colors.grey70,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0
  };
}

function getOptionContentStyle({
  $selected,
  $theme
}) {
  return {
    color: $theme.colors.grey70,
    backgroundColor: $selected ? $theme.colors.grey10 : 'transparent',
    fontWeight: 'normal',
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '16px',
    paddingRight: '16px'
  };
}

function getPlaceholderStyle({
  $theme
}) {
  return {
    display: 'flex',
    alignItems: 'center',
    color: $theme.colors.grey50
  };
}

function getInputStyle({
  $theme
}) {
  return {
    color: $theme.colors.grey70,
    cursor: 'pointer'
  };
}

function getSingleValueStyle({
  $theme
}) {
  return {
    color: $theme.colors.grey70
  };
}

function getPopoverBodyStyle(zIndex) {
  const style = {};

  if (!(0, _isNil.default)(zIndex)) {
    style.zIndex = zIndex;
  }

  return style;
}